import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, LinearProgress, Typography } from '@material-ui/core';


const LoadingBox = ({ label }) => (
  <Grid item xs={12}>
    <Box px={5} pt={3} pb={1} width="100%" display="flex" flexDirection="column">
      <LinearProgress />
      <Typography variant="overline" align="center">Cargando {label}</Typography>
    </Box>
  </Grid>
);

LoadingBox.propTypes = {
  label: PropTypes.string.isRequired,
};

export {
  LoadingBox,
};